import { combineReducers } from 'redux';
import sidebar from './sidebar/reducers';
import clientInformation from './clientInformation/reducers';
import trust from './trust/reducers';
import portfolio from './portfolio/reducers';
import classes from './classes/reducers';
import prospectus from './prospectus/reducers';
import filing from './filing/reducers';
import security from './security/reducers';
import user from './user/reducers';
import role from './role/reducers';
import account from './account/reducers';
import state from './state/reducers';

export default combineReducers({
    sidebar: sidebar,
    clientInformation: clientInformation,
    trust: trust,
    portfolio: portfolio,
    classes: classes,
    prospectus: prospectus,
    filing: filing,
    security: security,
    user: user,
    role: role,
    account: account,
    state: state
});



// WEBPACK FOOTER //
// ./src/services/redux/employee/index.js